window.addEventListener('DOMContentLoaded', () =>
{
  if(document.querySelector('#upForBlog'))
  {
    const arrowTop = document.querySelector('#upForBlog');
    arrowTop.onclick = function()
    {
      window.scrollTo(scrollX, 0);
    };
    window.addEventListener('scroll', function()
    {
      arrowTop.hidden = (this.scrollY < document.documentElement.clientHeight);
    });
  }
});
